<template>
    <el-dialog title="订单改派" :visible.sync="show" width="1100px" :close-on-click-modal="false" append-to-body
        :before-close="dialogClose">
        <p class="dialog_tips">请输入车辆号牌、司机姓名搜索车辆后，再改派订单</p>
        <custom-table :has-organization="false" ref="driverTable" :customOptions="driverOptions"
            :columns="driverColumns" :refreshShow="false" :paging="false" labelWidth="135" style="height: 65vh">
            <template slot-scope="{ item, row }">
                <template v-if="item.prop == 'commissionAmount'">
                    <span class="util-money"> ¥{{ row.commissionAmount || 0 }} </span>
                </template>
                <template v-else-if="item.prop == 'licenseNo'">
                    <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(row.licenseNo) }}</span>
                    <span v-else>-</span>
                </template>
                <template v-else-if="item.prop == 'driverName'">
                    <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ?
                        row[item.prop]
                        : "-" }}</span>
                </template>
                <template v-else-if="item.prop == 'driverPhone'">
                    <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ?
                        row[item.prop]
                        : "-" }}</span>
                </template>

                <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
            </template>
            <template slot="table-operation">
                <el-table-column label="操作" fixed="right">
                    <div slot-scope="{ row }" class="custom-action">
                        <el-button type="text" @click="assignFn(row)" :loading="loading">指派</el-button>
                    </div>
                </el-table-column>
            </template>
        </custom-table>
    </el-dialog>
</template>

<script>

export default {
    name: "orderReassign",
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        orderId: {
            type: [String, Number],
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        console.log('this.orderId1111', this.orderId)
        this.driverOptions.params.id = this.orderId;
        this.driverOptions.firstNotRequest = false;
    },
    data() {
        return {
            // 配置项
            driverOptions: {
                firstNotRequest: true,
                // 请求的列表url
                url: "/api/v1/manage/order/hitchRide/dispatch/vehicle",
                // 请求的参数列表
                params: {
                    id: ""
                },
                search: [
                    { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
                    { type: "input", field: "driverName", name: "司机姓名", value: "" },
                    { type: "input", field: "driverPhone", name: "司机电话", value: "" },
                ],
            },
            // 表头
            driverColumns: [
                { prop: "licenseNo", label: "车辆号牌", minWidth: 190 },
                { prop: "vehicleSeat", label: "座位数", minWidth: 200 },
                { prop: "driverName", label: "司机信息", minWidth: 200 },
                { prop: "driverPhone", label: "联系电话", minWidth: 130 },
                { prop: "commissionAmount", label: "该笔订单司机收益", minWidth: 130 },
            ],
        };
    },

    methods: {
        dialogClose() {
            this.driverOptions.firstNotRequest = true;
            this.$emit('close');
        },
        async assignFn(row) {
            this.$emit('assign', row);
        },
    },
};
</script>

<style scoped lang="less">
.dialog_tips {
    color: red;
    margin: 10px 0 5px;
}
</style>
